import React, { useState } from 'react';
import { Form, Select } from 'antd';
import style from './deployment.module.sass';
import { Http } from '../../../../helpers/axois';
import { useSelector } from 'react-redux';
import { useToast } from '../../../../helpers/commonFunction';
import { AppState } from '../../../../stateManager/store';

const { Option } = Select;

interface Props {
    appDetails: any
    currentDeploy: any
    data: any
    envList: any
    setIsFormSelected: any;
    appType: string;
}

const LiveDeployment: React.FC<Props> = (props) => {
    const list = props.envList
    const [bothandles, setBotHandles] = useState([]);
    const { ErrorToast } = useToast()
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    const getBotHandles = (url: string) => {
        if((!orgPermissions.includes('deploy.Deploy') || !orgPermissions.includes('app.View')) && loggedInUserId!=selectedOrg?.owner  ){
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            return
        }
        Http.post(`/botHandles?orgId=${selectedOrg?.id}`, { flowUrl: url }).subscribe((res: any) => {
            setBotHandles(res)
        }, (err) => {
            if (err == "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            }
            console.log({ err })
        })
    }

    return (
        <React.Fragment>
            <div className={'override-content row'}>
                <div className='col-md-12'>
                    <Form.Item
                        label={"Environment"}
                    >
                        <Select data-test-id="bpmn_env" placeholder="Testing"
                            onChange={(e: string) => {
                                const flowData = list.find((env: any) => env.id === e)
                                if (flowData.url && props.appType === "a8chat") {
                                    getBotHandles(flowData?.url);
                                }
                                props.data("envId", e)
                                }} style={{ width: '100%' }}>
                            {
                                list && list.length > 0 && list.map((data: any, key: number) => {
                                    return (
                                        <Option data-test-id={`bpmn_env_name${data.name}`} value={data.id} key={key}>
                                            {data.name}
                                            &nbsp;<small className={style.evnHost}>({data.url})</small>
                                        </Option>
                                    );
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>
                {bothandles?.length > 0 && props.appType === "a8chat" && <div className='col-md-12'>
                    <Form.Item
                        label={"Bot Handle"}
                    >
                        <Select data-test-id="select_botHandle" placeholder="Bothandle"
                            onChange={(e: string) => props.data("botHandle", e)} style={{ width: '100%' }}>
                            {
                                bothandles && bothandles.length > 0 && bothandles.map((data: { name: string, id: string }, key: number) => {
                                    return (
                                        <Option data-test-id={`environment${data.name}`} value={data.name} key={data.id}>
                                            {data.name}
                                        </Option>
                                    );
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>}
            </div>
        </React.Fragment>
    )
}

export default LiveDeployment;
